<script>
import Layout from '../../../layouts/auth'
import appConfig from '@/app.config'
import { required, minLength, maxLength } from 'vuelidate/lib/validators'
import { RESET_PASSWORD } from '@/services/api/auth'
import { MixPanel } from '@/mixin/mixpanel'

export default {
  page: {
    title: 'Lupa Kata Sandi',
    meta: [
      {
        name: 'description',
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
  },
  data() {
    return {
      password: '',
      repassword: '',
      showPassword: false,
      showRepassword: false,
      submitted: false,
      passwordError: false,
      differentPass: false,
      likeOldPass: false,
      email: localStorage.getItem('emailOTP'),
      otp: localStorage.getItem('otpCode'),
      companyName: '',
      username: '',
      accessRight: '',
      userId: null,
      mode: this.$store.state.config.mode,
    }
  },
  validations: {
    password: {
      required,
      minLength: minLength(4),
      maxLength: maxLength(50),
    },
    repassword: {
      required,
      minLength: minLength(4),
      maxLength: maxLength(50),
    },
  },
  computed: {
    notification() {
      return this.$store ? this.$store.state.notification : null
    },
  },
  methods: {
    togglePassword() {
      this.showPassword = !this.showPassword
    },
    toggleRepassword() {
      this.showRepassword = !this.showRepassword
    },
    handleSubmit() {
      this.submitted = true
      this.$v.$touch()
      if (this.$v.$invalid) return
      const input = {
        email: this.email,
        otp: this.otp,
        password: this.password,
        passwordConfirm: this.repassword,
      }
      this.$apollo
        .mutate({
          mutation: RESET_PASSWORD,
          variables: {
            input: input,
          },
        })
        .then((response) => {
          if (
            response.data.resetPasswordOtp.resetPasswordOtp.message ==
            'Password reset failed, confirm password invalid'
          ) {
            this.passwordError = true
            this.differentPass = true
            setTimeout(() => {
              this.passwordError = false
              this.differentPass = false
            }, 3000)
          } else if (
            response.data.resetPasswordOtp.resetPasswordOtp.message ==
            'Password reset failed, new password cannot be the same as the old password'
          ) {
            this.passwordError = true
            this.likeOldPass = true
            setTimeout(() => {
              this.passwordError = false
              this.likeOldPass = false
            }, 3000)
          } else if (
            response.data.resetPasswordOtp.resetPasswordOtp.message == 'Password reset successful'
          ) {
            this.$router.push({ name: 'Password Changed' })
            this.companyName = response.data.resetPasswordOtp.resetPasswordOtp.users.companyName
            this.username = response.data.resetPasswordOtp.resetPasswordOtp.users.fullname
            this.accessRight = response.data.resetPasswordOtp.resetPasswordOtp.users.accessRight
            this.userId = response.data.resetPasswordOtp.resetPasswordOtp.users.userId
            MixPanel.methods.actionResetPassword(
              this.mode,
              this.companyName,
              this.username,
              this.email,
              this.accessRight,
              this.userId
            )
          }
        })
    },
  },
}
</script>
<template>
  <Layout>
    <div class="mc-auth__form">
      <h1 class="mc-auth__logo pt-5">
        <router-link to="/">
          <img src="@/assets/images/main-logo.png" alt />
        </router-link>
      </h1>
      <div class="mc-auth__form-wrapper mc-auth__form-wrapper--forgot">
        <h4 class="mc-auth__label">Atur Ulang Kata Sandi</h4>
        <p>Kata sandi yang baru harus berbeda dari kata sandi yang digunakan sebelumnya.</p>
        <b-form @submit.prevent="handleSubmit">
          <b-form-group class="mb-2 form-password text-start" id="input-group-1">
            <label for="text-password">Kata Sandi Baru <span class="text-danger">*</span></label>
            <b-form-input
              v-if="showPassword"
              id="text-password"
              v-model="$v.password.$model"
              type="text"
              placeholder="Kata sandi baru"
              :class="{
                'is-invalid': (submitted && $v.password.$error) || (submitted && passwordError),
              }"
            ></b-form-input>
            <b-form-input
              v-else
              id="text-password"
              v-model="$v.password.$model"
              type="password"
              placeholder="Kata sandi baru"
              :class="{
                'is-invalid': (submitted && $v.password.$error) || (submitted && passwordError),
              }"
            ></b-form-input>
            <i
              @click="togglePassword"
              class="mc-fa-repassword"
              :class="{
                'icon-outline_eye': showPassword,
                'icon-outline_eye-off-2': !showPassword,
              }"
            ></i>
            <div
              v-if="(submitted && $v.password.$error) || (submitted && passwordError)"
              class="invalid-feedback"
            >
              <span v-if="likeOldPass">Kata sandi baru tidak boleh sama dengan saat ini.</span>
              <span v-if="!$v.password.required">Kata sandi wajib terisi.</span>
              <span v-if="!$v.password.minLength">Kata sandi baru minimal 4 karakter.</span>
              <span v-if="!$v.password.maxLength">Kata sandi baru maksimal 50 karakter.</span>
            </div>
          </b-form-group>
          <b-form-group class="mb-2 form-password text-start" id="input-group-2">
            <label for="text-repassword"
              >Ulangi Kata Sandi Baru <span class="text-danger">*</span></label
            >
            <b-form-input
              v-if="showRepassword"
              id="text-repassword"
              v-model="$v.repassword.$model"
              type="text"
              placeholder="Ulangi kata sandi baru"
              :class="{
                'is-invalid': (submitted && $v.repassword.$error) || (submitted && passwordError),
              }"
            ></b-form-input>
            <b-form-input
              v-else
              id="text-repassword"
              v-model="$v.repassword.$model"
              type="password"
              placeholder="Ulangi kata sandi baru"
              :class="{
                'is-invalid': (submitted && $v.repassword.$error) || (submitted && passwordError),
              }"
            ></b-form-input>
            <i
              @click="toggleRepassword"
              class="mc-fa-repassword"
              :class="{
                'icon-outline_eye': showRepassword,
                'icon-outline_eye-off-2': !showRepassword,
              }"
            ></i>
            <div
              v-if="(submitted && $v.repassword.$error) || (submitted && passwordError)"
              class="invalid-feedback d-block"
            >
              <span v-if="differentPass">Kata sandi tidak cocok. </span>
              <span v-if="!$v.repassword.required">Kata sandi wajib terisi.</span>
              <span v-if="!$v.repassword.minLength">Kata sandi baru minimal 4 karakter.</span>
              <span v-if="!$v.repassword.maxLength">Kata sandi baru maksimal 50 karakter.</span>
            </div>
          </b-form-group>
          <div class="mt-5">
            <b-button type="submit" variant="primary" class="w-100"
              >Simpan Kata Sandi Baru</b-button
            >
          </div>
        </b-form>
      </div>
      <div class="mc-auth__copyright">
        <span
          >Dipersembahkan oleh <img src="@/assets/images/copyright-logo.png" alt height="18" class="mt-2"
        /></span>
      </div>
    </div>
  </Layout>
</template>
